export default __webpack_public_path__ + "static/media/ss5.bd53c481.JPG";